import React, { useState, useEffect, useCallback } from 'react';

const COOKIE_NAME = 'chatlab_consent';
const COOKIE_DAYS = 365;
const SUPPORTED_LANGS = ['pl', 'de', 'es', 'fr', 'it', 'tr', 'hu', 'ro', 'cs', 'sk'];

const TRANSLATIONS = {
  en: {
    banner_title: 'This website uses cookies',
    banner_message: 'We use cookies to personalise content and ads, to provide social media features and to analyse our traffic. We also share information about your use of our site with advertising and analytics partners who may combine it with other information that you\'ve provided to them or that they\'ve collected from your use of their services.',
    customize: 'Customize',
    accept_all: 'Accept All',
    deny_all: 'Deny All',
    save: 'Save Preferences',
    title: 'Cookie Preferences',
    necessary: 'Necessary',
    necessary_desc: 'Essential for the website to function properly.',
    statistics: 'Statistics',
    statistics_desc: 'Help us understand how visitors interact with our website.',
    marketing: 'Marketing',
    marketing_desc: 'Used to deliver relevant ads and measure campaign effectiveness.',
    preferences: 'Preferences',
    preferences_desc: 'Remember your settings and personalization choices.',
    always_on: 'Always on',
    read_more: 'Read more',
  },
  pl: {
    banner_title: 'Ta strona używa plików cookie',
    banner_message: 'Używamy plików cookie do personalizacji treści i reklam, udostępniania funkcji mediów społecznościowych oraz analizy ruchu. Udostępniamy również informacje o korzystaniu z naszej strony partnerom reklamowym i analitycznym, którzy mogą je łączyć z innymi informacjami, które im przekazałeś lub które zebrali w związku z korzystaniem przez Ciebie z ich usług.',
    customize: 'Dostosuj',
    accept_all: 'Akceptuj wszystkie',
    deny_all: 'Odrzuć wszystkie',
    save: 'Zapisz preferencje',
    title: 'Preferencje plików cookie',
    necessary: 'Niezbędne',
    necessary_desc: 'Niezbędne do prawidłowego działania strony.',
    statistics: 'Statystyczne',
    statistics_desc: 'Pomagają zrozumieć, jak odwiedzający korzystają ze strony.',
    marketing: 'Marketingowe',
    marketing_desc: 'Służą do wyświetlania trafnych reklam i mierzenia skuteczności kampanii.',
    preferences: 'Preferencje',
    preferences_desc: 'Zapamiętują ustawienia i personalizację.',
    always_on: 'Zawsze włączone',
    read_more: 'Czytaj więcej',
  },
  de: {
    banner_title: 'Diese Website verwendet Cookies',
    banner_message: 'Wir verwenden Cookies, um Inhalte und Anzeigen zu personalisieren, Funktionen für soziale Medien bereitzustellen und unseren Datenverkehr zu analysieren. Wir teilen auch Informationen über Ihre Nutzung unserer Website mit unseren Werbe- und Analysepartnern, die diese mit anderen Informationen kombinieren können, die Sie ihnen bereitgestellt haben oder die sie im Rahmen Ihrer Nutzung ihrer Dienste gesammelt haben.',
    customize: 'Anpassen',
    accept_all: 'Alle akzeptieren',
    deny_all: 'Alle ablehnen',
    save: 'Einstellungen speichern',
    title: 'Cookie-Einstellungen',
    necessary: 'Notwendig',
    necessary_desc: 'Essentiell für die ordnungsgemäße Funktion der Website.',
    statistics: 'Statistik',
    statistics_desc: 'Helfen uns zu verstehen, wie Besucher mit unserer Website interagieren.',
    marketing: 'Marketing',
    marketing_desc: 'Werden verwendet, um relevante Anzeigen zu schalten und die Kampagneneffektivität zu messen.',
    preferences: 'Präferenzen',
    preferences_desc: 'Merken sich Ihre Einstellungen und Personalisierungen.',
    always_on: 'Immer aktiv',
    read_more: 'Mehr erfahren',
  },
  es: {
    banner_title: 'Este sitio web utiliza cookies',
    banner_message: 'Utilizamos cookies para personalizar el contenido y los anuncios, ofrecer funciones de redes sociales y analizar nuestro tráfico. También compartimos información sobre el uso que haces de nuestro sitio con nuestros partners de publicidad y analítica, quienes pueden combinarla con otra información que les hayas proporcionado o que hayan recopilado a partir del uso que hayas hecho de sus servicios.',
    customize: 'Personalizar',
    accept_all: 'Aceptar todas',
    deny_all: 'Rechazar todas',
    save: 'Guardar preferencias',
    title: 'Preferencias de cookies',
    necessary: 'Necesarias',
    necessary_desc: 'Imprescindibles para que el sitio web funcione correctamente.',
    statistics: 'Estadísticas',
    statistics_desc: 'Nos ayudan a entender cómo interactúan los visitantes con nuestro sitio web.',
    marketing: 'Marketing',
    marketing_desc: 'Se utilizan para ofrecer anuncios relevantes y medir la eficacia de las campañas.',
    preferences: 'Preferencias',
    preferences_desc: 'Recuerdan tus ajustes y opciones de personalización.',
    always_on: 'Siempre activas',
    read_more: 'Más información',
  },
  fr: {
    banner_title: 'Ce site utilise des cookies',
    banner_message: 'Nous utilisons des cookies pour personnaliser le contenu et les annonces, offrir des fonctionnalités relatives aux médias sociaux et analyser notre trafic. Nous partageons également des informations sur l\'utilisation de notre site avec nos partenaires de publicité et d\'analyse, qui peuvent combiner celles-ci avec d\'autres informations que vous leur avez fournies ou qu\'ils ont collectées lors de votre utilisation de leurs services.',
    customize: 'Personnaliser',
    accept_all: 'Tout accepter',
    deny_all: 'Tout refuser',
    save: 'Enregistrer les préférences',
    title: 'Préférences de cookies',
    necessary: 'Nécessaires',
    necessary_desc: 'Indispensables au bon fonctionnement du site web.',
    statistics: 'Statistiques',
    statistics_desc: 'Nous aident à comprendre comment les visiteurs interagissent avec notre site web.',
    marketing: 'Marketing',
    marketing_desc: 'Utilisés pour diffuser des annonces pertinentes et mesurer l\'efficacité des campagnes.',
    preferences: 'Préférences',
    preferences_desc: 'Mémorisent vos paramètres et vos choix de personnalisation.',
    always_on: 'Toujours activé',
    read_more: 'En savoir plus',
  },
  it: {
    banner_title: 'Questo sito web utilizza i cookie',
    banner_message: 'Utilizziamo i cookie per personalizzare contenuti e annunci, fornire funzionalità per i social media e analizzare il nostro traffico. Condividiamo inoltre informazioni sul modo in cui utilizzi il nostro sito con i nostri partner di pubblicità e analisi, che potrebbero combinarle con altre informazioni che hai fornito loro o che hanno raccolto dall\'utilizzo dei loro servizi.',
    customize: 'Personalizza',
    accept_all: 'Accetta tutti',
    deny_all: 'Rifiuta tutti',
    save: 'Salva preferenze',
    title: 'Preferenze cookie',
    necessary: 'Necessari',
    necessary_desc: 'Essenziali per il corretto funzionamento del sito web.',
    statistics: 'Statistici',
    statistics_desc: 'Ci aiutano a capire come i visitatori interagiscono con il nostro sito web.',
    marketing: 'Marketing',
    marketing_desc: 'Utilizzati per offrire annunci pertinenti e misurare l\'efficacia delle campagne.',
    preferences: 'Preferenze',
    preferences_desc: 'Memorizzano le tue impostazioni e le scelte di personalizzazione.',
    always_on: 'Sempre attivi',
    read_more: 'Leggi di più',
  },
  tr: {
    banner_title: 'Bu web sitesi çerezleri kullanır',
    banner_message: 'İçeriği ve reklamları kişiselleştirmek, sosyal medya özellikleri sağlamak ve trafiğimizi analiz etmek için çerezler kullanıyoruz. Ayrıca sitemizi kullanımınızla ilgili bilgileri, kendilerine sağladığınız veya hizmetlerini kullanımınızdan topladıkları diğer bilgilerle birleştirebilecek reklam ve analiz ortaklarımızla paylaşıyoruz.',
    customize: 'Özelleştir',
    accept_all: 'Tümünü kabul et',
    deny_all: 'Tümünü reddet',
    save: 'Tercihleri kaydet',
    title: 'Çerez tercihleri',
    necessary: 'Gerekli',
    necessary_desc: 'Web sitesinin düzgün çalışması için zorunludur.',
    statistics: 'İstatistik',
    statistics_desc: 'Ziyaretçilerin web sitemizle nasıl etkileşime girdiğini anlamamıza yardımcı olur.',
    marketing: 'Pazarlama',
    marketing_desc: 'İlgili reklamları sunmak ve kampanya etkinliğini ölçmek için kullanılır.',
    preferences: 'Tercihler',
    preferences_desc: 'Ayarlarınızı ve kişiselleştirme seçimlerinizi hatırlar.',
    always_on: 'Her zaman etkin',
    read_more: 'Daha fazla bilgi',
  },
  hu: {
    banner_title: 'Ez a webhely sütiket használ',
    banner_message: 'Sütiket használunk a tartalom és a hirdetések személyre szabásához, közösségi média funkciók biztosításához és a forgalmunk elemzéséhez. A webhelyünk használatáról szóló információkat megosztjuk hirdetési és analitikai partnereinkkel is, akik ezeket összekapcsolhatják más adatokkal, amelyeket Ön adott meg nekik, vagy amelyeket az Ön szolgáltatáshasználatából gyűjtöttek.',
    customize: 'Testreszabás',
    accept_all: 'Összes elfogadása',
    deny_all: 'Összes elutasítása',
    save: 'Beállítások mentése',
    title: 'Sütibeállítások',
    necessary: 'Szükséges',
    necessary_desc: 'Elengedhetetlen a webhely megfelelő működéséhez.',
    statistics: 'Statisztika',
    statistics_desc: 'Segít megértenünk, hogyan lépnek kapcsolatba a látogatók a webhelyünkkel.',
    marketing: 'Marketing',
    marketing_desc: 'Releváns hirdetések megjelenítésére és a kampányok hatékonyságának mérésére szolgál.',
    preferences: 'Preferenciák',
    preferences_desc: 'Megjegyzi az Ön beállításait és személyre szabási döntéseit.',
    always_on: 'Mindig aktív',
    read_more: 'További információ',
  },
  ro: {
    banner_title: 'Acest site web utilizează cookie-uri',
    banner_message: 'Utilizăm cookie-uri pentru a personaliza conținutul și anunțurile, pentru a oferi funcții de rețele sociale și pentru a analiza traficul. De asemenea, partajăm informații despre modul în care utilizați site-ul nostru cu partenerii noștri de publicitate și de analiză, care le pot combina cu alte informații pe care li le-ați furnizat sau pe care le-au colectat din utilizarea serviciilor lor.',
    customize: 'Personalizați',
    accept_all: 'Acceptați toate',
    deny_all: 'Respingeți toate',
    save: 'Salvați preferințele',
    title: 'Preferințe privind cookie-urile',
    necessary: 'Necesare',
    necessary_desc: 'Esențiale pentru funcționarea corectă a site-ului web.',
    statistics: 'Statistici',
    statistics_desc: 'Ne ajută să înțelegem cum interacționează vizitatorii cu site-ul nostru.',
    marketing: 'Marketing',
    marketing_desc: 'Utilizate pentru a afișa anunțuri relevante și pentru a măsura eficiența campaniilor.',
    preferences: 'Preferințe',
    preferences_desc: 'Rețin setările și opțiunile dumneavoastră de personalizare.',
    always_on: 'Întotdeauna active',
    read_more: 'Aflați mai multe',
  },
  cs: {
    banner_title: 'Tento web používá soubory cookie',
    banner_message: 'Soubory cookie používáme k personalizaci obsahu a reklam, k poskytování funkcí sociálních sítí a k analýze návštěvnosti. Informace o tom, jak náš web používáte, sdílíme také s našimi reklamními a analytickými partnery, kteří je mohou zkombinovat s dalšími údaji, které jste jim poskytli nebo které získali na základě vašeho používání jejich služeb.',
    customize: 'Přizpůsobit',
    accept_all: 'Přijmout vše',
    deny_all: 'Odmítnout vše',
    save: 'Uložit předvolby',
    title: 'Předvolby souborů cookie',
    necessary: 'Nezbytné',
    necessary_desc: 'Nezbytné pro správné fungování webu.',
    statistics: 'Statistické',
    statistics_desc: 'Pomáhají nám pochopit, jak návštěvníci s naším webem pracují.',
    marketing: 'Marketingové',
    marketing_desc: 'Slouží k zobrazování relevantních reklam a k měření účinnosti kampaní.',
    preferences: 'Předvolby',
    preferences_desc: 'Zapamatují si vaše nastavení a volby personalizace.',
    always_on: 'Vždy aktivní',
    read_more: 'Zjistit více',
  },
  sk: {
    banner_title: 'Táto webová stránka používa súbory cookie',
    banner_message: 'Súbory cookie používame na personalizáciu obsahu a reklám, na poskytovanie funkcií sociálnych sietí a na analýzu návštevnosti. Informácie o tom, ako našu stránku používate, zdieľame aj s našimi reklamnými a analytickými partnermi, ktorí ich môžu skombinovať s ďalšími údajmi, ktoré ste im poskytli alebo ktoré získali z vášho používania ich služieb.',
    customize: 'Prispôsobiť',
    accept_all: 'Prijať všetko',
    deny_all: 'Odmietnuť všetko',
    save: 'Uložiť predvoľby',
    title: 'Predvoľby súborov cookie',
    necessary: 'Nevyhnutné',
    necessary_desc: 'Nevyhnutné pre správne fungovanie stránky.',
    statistics: 'Štatistické',
    statistics_desc: 'Pomáhajú nám pochopiť, ako návštevníci našu stránku používajú.',
    marketing: 'Marketingové',
    marketing_desc: 'Slúžia na zobrazovanie relevantných reklám a na meranie účinnosti kampaní.',
    preferences: 'Predvoľby',
    preferences_desc: 'Zapamätajú si vaše nastavenia a voľby personalizácie.',
    always_on: 'Vždy aktívne',
    read_more: 'Zistiť viac',
  },
};

function detectLang() {
  if (typeof window === 'undefined') return 'en';
  const path = window.location.pathname;
  for (const lang of SUPPORTED_LANGS) {
    if (path === `/${lang}` || path.startsWith(`/${lang}/`)) return lang;
  }
  return 'en';
}

function cookiesHref() {
  const lang = detectLang();
  return lang === 'en' ? '/cookies/' : `/${lang}/cookies/`;
}

function readConsent() {
  if (typeof document === 'undefined') return null;
  try {
    const match = document.cookie.match(/(?:^|; )chatlab_consent=([^;]*)/);
    if (match) return JSON.parse(decodeURIComponent(match[1]));
  } catch (e) { /* cookie parse error */ }
  return null;
}

function writeConsent(consent) {
  const data = { ...consent, timestamp: Date.now() };
  const value = encodeURIComponent(JSON.stringify(data));
  const expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const domain = isLocal ? '' : ';domain=.chatlab.com';
  document.cookie = `${COOKIE_NAME}=${value};expires=${expires};path=/${domain};SameSite=Lax`;
}

function pushConsentToGTM(consent) {
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag('consent', 'update', {
    ad_storage: consent.marketing ? 'granted' : 'denied',
    ad_user_data: consent.marketing ? 'granted' : 'denied',
    ad_personalization: consent.marketing ? 'granted' : 'denied',
    analytics_storage: consent.statistics ? 'granted' : 'denied',
    functionality_storage: consent.preferences ? 'granted' : 'denied',
    personalization_storage: consent.preferences ? 'granted' : 'denied',
  });
  gtag('set', 'ads_data_redaction', !consent.marketing);
  if (consent.statistics) window.dataLayer.push({ event: 'cookie_consent_statistics' });
  if (consent.marketing) window.dataLayer.push({ event: 'cookie_consent_marketing' });
  if (consent.preferences) window.dataLayer.push({ event: 'cookie_consent_preferences' });
  window.dataLayer.push({ event: 'cookie_consent_update' });
}

const CATEGORIES = ['necessary', 'statistics', 'marketing', 'preferences'];

const CookieIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="8" cy="9" r="1.5" fill="currentColor"/>
    <circle cx="14.5" cy="7.5" r="1" fill="currentColor"/>
    <circle cx="16" cy="14" r="1.5" fill="currentColor"/>
    <circle cx="9.5" cy="15" r="1" fill="currentColor"/>
    <circle cx="12" cy="11.5" r="1" fill="currentColor"/>
  </svg>
);

const Toggle = ({ checked, disabled, onClick }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    onClick={onClick}
    disabled={disabled}
    className={`
      relative inline-flex h-6 w-11 shrink-0 rounded-full border-2 border-transparent
      transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2
      ${checked ? 'bg-[var(--cl-ink)]' : 'bg-[var(--cl-rule-strong)]'}
      ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
    `}
  >
    <span
      className={`
        pointer-events-none inline-block h-5 w-5 rounded-full bg-white
        ring-0 transition-transform duration-300
        ${checked ? 'translate-x-5' : 'translate-x-0'}
      `}
    />
  </button>
);

const CookieConsent = () => {
  const [view, setView] = useState(null);
  const [sliding, setSliding] = useState(false);
  const [consent, setConsent] = useState({
    necessary: true,
    statistics: false,
    marketing: false,
    preferences: false,
  });

  const tx = TRANSLATIONS[detectLang()] || TRANSLATIONS.en;

  useEffect(() => {
    const saved = readConsent();
    if (saved) {
      setConsent({ necessary: true, statistics: !!saved.statistics, marketing: !!saved.marketing, preferences: !!saved.preferences });
      setView('icon');
    } else {
      setView('banner');
      requestAnimationFrame(() => requestAnimationFrame(() => setSliding(true)));
    }
  }, []);

  const dismiss = useCallback((newConsent) => {
    writeConsent(newConsent);
    pushConsentToGTM(newConsent);
    setConsent(newConsent);
    setSliding(false);
    setTimeout(() => setView('icon'), 400);
  }, []);

  const handleAcceptAll = useCallback(() => {
    dismiss({ necessary: true, statistics: true, marketing: true, preferences: true });
  }, [dismiss]);

  const handleDeny = useCallback(() => {
    dismiss({ necessary: true, statistics: false, marketing: false, preferences: false });
  }, [dismiss]);

  const handleSave = useCallback(() => {
    dismiss(consent);
  }, [dismiss, consent]);

  const openDetails = useCallback(() => {
    const saved = readConsent();
    if (saved) {
      setConsent({ necessary: true, statistics: !!saved.statistics, marketing: !!saved.marketing, preferences: !!saved.preferences });
    }
    setView('details');
    requestAnimationFrame(() => requestAnimationFrame(() => setSliding(true)));
  }, []);

  const toggle = useCallback((key) => {
    if (key === 'necessary') return;
    setConsent(prev => ({ ...prev, [key]: !prev[key] }));
  }, []);

  if (view === 'icon') {
    return (
      <button
        onClick={openDetails}
        aria-label={tx.title}
        className="fixed bottom-4 left-4 z-[9999] w-10 h-10 rounded-full border border-[var(--cl-rule)] bg-[var(--cl-surface)]/90 backdrop-blur-sm flex items-center justify-center text-[var(--cl-muted)] hover:text-[var(--cl-ink)] transition-colors duration-300 cursor-pointer"
      >
        <CookieIcon />
      </button>
    );
  }

  if (!view) return null;

  const isVisible = sliding;

  return (
    <>
      {isVisible && (
        <div className="fixed inset-0 z-[9998] bg-black/20 backdrop-blur-[2px]" />
      )}

      <div
        role="dialog"
        aria-modal="true"
        aria-label={view === 'banner' ? tx.banner_title : tx.title}
        className={`fixed inset-0 z-[9999] flex items-center justify-center p-4 transition-opacity duration-400 ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
      >
        <div className="w-full max-w-xl bg-[var(--cl-surface)] rounded-[4px] border border-[var(--cl-rule)] overflow-hidden">

          {view === 'banner' && (
            <div className="p-7 sm:p-8">
              <h3 className="text-lg font-semibold text-[var(--cl-ink)] mb-3">
                {tx.banner_title}
              </h3>
              <p className="text-sm leading-relaxed text-[var(--cl-ink-2)] mb-6 text-justify">
                {tx.banner_message}
              </p>
              <div className="flex items-center gap-5">
                <button
                  onClick={() => setView('details')}
                  className="text-[13px] font-medium text-[var(--cl-ink-2)] hover:text-[var(--cl-ink)] underline-offset-4 hover:underline cursor-pointer"
                >
                  {tx.customize}
                </button>
                <button
                  onClick={handleDeny}
                  className="text-[13px] font-medium text-[var(--cl-ink-2)] hover:text-[var(--cl-ink)] underline-offset-4 hover:underline cursor-pointer"
                >
                  {tx.deny_all}
                </button>
                <button
                  onClick={handleAcceptAll}
                  className="ml-auto h-11 px-8 text-[13px] font-semibold text-white bg-[var(--cl-ink)] border-[1.5px] border-[var(--cl-ink)] rounded-full hover:bg-[var(--cl-ink-2)] transition-all duration-300 cursor-pointer"
                >
                  {tx.accept_all}
                </button>
              </div>
            </div>
          )}

          {view === 'details' && (
            <div className="p-7 sm:p-8">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-[var(--cl-ink)]">
                  {tx.title}
                </h3>
                <a
                  href={cookiesHref()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-[var(--cl-muted)] hover:text-[var(--cl-ink)] transition-colors duration-200"
                >
                  {tx.read_more}
                </a>
              </div>

              <div className="mb-6">
                {CATEGORIES.map((key, i) => (
                  <div
                    key={key}
                    className={`flex items-center justify-between py-3 ${i < CATEGORIES.length - 1 ? 'border-b border-[var(--cl-rule)]' : ''}`}
                  >
                    <div className="flex-1 pr-3 min-w-0">
                      <div className="text-sm font-medium text-[var(--cl-ink)]">
                        {tx[key]}
                        {key === 'necessary' && (
                          <span className="text-[11px] text-[var(--cl-muted)] ml-2 font-normal">{tx.always_on}</span>
                        )}
                      </div>
                      <p className="text-xs text-[var(--cl-muted)] mt-0.5 leading-snug">
                        {tx[`${key}_desc`]}
                      </p>
                    </div>
                    <Toggle
                      checked={consent[key]}
                      disabled={key === 'necessary'}
                      onClick={() => toggle(key)}
                    />
                  </div>
                ))}
              </div>

              <div className="flex gap-2">
                <button
                  onClick={handleDeny}
                  className="flex-1 h-11 text-[13px] font-medium text-[var(--cl-muted)] bg-transparent border-[1.5px] border-[var(--cl-rule)] rounded-full hover:bg-[var(--cl-surface-2)] transition-all duration-300 cursor-pointer"
                >
                  {tx.deny_all}
                </button>
                <button
                  onClick={handleSave}
                  className="flex-1 h-11 text-[13px] font-medium text-[var(--cl-ink)] bg-transparent border-[1.5px] border-[var(--cl-rule)] rounded-full hover:bg-[var(--cl-surface-2)] transition-all duration-300 cursor-pointer"
                >
                  {tx.save}
                </button>
                <button
                  onClick={handleAcceptAll}
                  className="flex-1 h-11 text-[13px] font-semibold text-white bg-[var(--cl-ink)] border-[1.5px] border-[var(--cl-ink)] rounded-full hover:bg-[var(--cl-ink-2)] transition-all duration-300 cursor-pointer"
                >
                  {tx.accept_all}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CookieConsent;
